export const roleManagementTranslations = {
    en: {
        // Page Title
        pageTitleMaster: "Role Master",

        // Table Headers
        srNo: "Sr. No.",
        role: "Role",
        roleType: "Role Type",
        updatedDate: "Updated Date",

        // Buttons & Actions
        addRole: "Add Role",
        addNewRole: "Add New Role",
        editRole: "Edit Role",
        deleteRole: "Delete Role",
        editRolePermission: "Edit Role Permission",

        // Dialogs
        updateRole: "Update Role",
        viewRoleDetails: "View \"{roleName}\" Role Details",

        // Lists & Messages
        roleList: "Role List",
        noRolesFound: "No roles found",
    },
    mr: {
        // Page Title
        pageTitleMaster: "भूमिका मास्टर",

        // Table Headers
        srNo: "क्र. नं.",
        role: "भूमिका",
        roleType: "भूमिका प्रकार",
        updatedDate: "अद्यतनित तारीख",

        // Buttons & Actions
        addRole: "भूमिका जोडा",
        addNewRole: "नवीन भूमिका जोडा",
        editRole: "भूमिका संपादित करा",
        deleteRole: "भूमिका हटवा",
        editRolePermission: "भूमिका अनुमती संपादित करा",

        // Dialogs
        updateRole: "भूमिका अद्यतनित करा",
        viewRoleDetails: " भूमिका तपशील व्यू करा",

        // Lists & Messages
        roleList: "भूमिका सूची",
        noRolesFound: "कोणतीही भूमिका सापडली नाही",
    }
};
